<template>
    <div>
      <h6
        style="font-weight: 400; margin: 0px !important; padding: 0px !important"
      >
        {{ VALUE }}
      </h6>
    </div>
  </template>
      <script>
  export default {
    data() {
      return {
        VALUE: "",
      };
    },
    created() {
      this.VALUE = this.params.value;
    },
  };
  </script>
      